/* touchscreen-detection.js */
/** detects if the current device is a touch-device */

export default function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
